/**
 * Exhaustive List of 192 GTA 3-Character FSA Postal Code Prefixes
 * Used for regional e-commerce validation on Hallmark Billiards Shopify Store.
 */
window.GTA_FSA_CODES = new Set([
  // Toronto - Scarborough
  'M1B', 'M1C', 'M1E', 'M1G', 'M1H', 'M1J', 'M1K', 'M1L', 'M1M', 'M1N', 'M1P', 'M1R', 'M1S', 'M1T', 'M1V', 'M1W', 'M1X',
  // Toronto - North York
  'M2H', 'M2J', 'M2K', 'M2L', 'M2M', 'M2N', 'M2P', 'M2R', 'M3A', 'M3B', 'M3C', 'M3H', 'M3J', 'M3K', 'M3L', 'M3M', 'M3N', 'M4A', 'M6A', 'M6B', 'M6L', 'M9L', 'M9M',
  // Toronto - East York & East Toronto
  'M4B', 'M4C', 'M4E', 'M4G', 'M4H', 'M4J', 'M4K', 'M4L', 'M4M',
  // Toronto - Central & Downtown
  'M4N', 'M4P', 'M4R', 'M4S', 'M4T', 'M4V', 'M4W', 'M4X', 'M4Y', 'M5A', 'M5B', 'M5C', 'M5E', 'M5G', 'M5H', 'M5J', 'M5K', 'M5L', 'M5M', 'M5N', 'M5P', 'M5R', 'M5S', 'M5T', 'M5V', 'M5W', 'M5X', 'M7A',
  // Toronto - York & West Toronto
  'M6C', 'M6E', 'M6G', 'M6H', 'M6J', 'M6K', 'M6M', 'M6N', 'M6P', 'M6R', 'M6S', 'M9N',
  // Toronto - Etobicoke
  'M8V', 'M8W', 'M8X', 'M8Y', 'M8Z', 'M9A', 'M9B', 'M9C', 'M9P', 'M9R', 'M9V', 'M9W',

  // Peel Region - Mississauga
  'L4T', 'L4W', 'L4X', 'L4Y', 'L4Z', 'L5A', 'L5B', 'L5C', 'L5E', 'L5G', 'L5H', 'L5J', 'L5K', 'L5L', 'L5M', 'L5N', 'L5R', 'L5S', 'L5T', 'L5V', 'L5W',
  // Peel Region - Brampton
  'L6P', 'L6R', 'L6S', 'L6T', 'L6V', 'L6W', 'L6X', 'L6Y', 'L6Z', 'L7A',
  // Peel Region - Caledon
  'L7C', 'L7E', 'L7K',

  // Halton Region - Oakville
  'L6H', 'L6J', 'L6K', 'L6L', 'L6M',
  // Halton Region - Burlington
  'L7L', 'L7M', 'L7N', 'L7P', 'L7R', 'L7S', 'L7T',
  // Halton Region - Milton
  'L9E', 'L9T',
  // Halton Region - Halton Hills
  'L7G', 'L7J',

  // York Region - Vaughan
  'L4H', 'L4J', 'L4K', 'L4L', 'L6A',
  // York Region - Markham
  'L3P', 'L3R', 'L3S', 'L6B', 'L6C', 'L6E', 'L6G',
  // York Region - Richmond Hill
  'L4B', 'L4C', 'L4E', 'L4S',
  // York Region - Newmarket
  'L3X', 'L3Y',
  // York Region - Aurora
  'L4G',
  // York Region - Stouffville
  'L4A',
  // York Region - King & Rural York
  'L7B', 'L0G',

  // Durham Region - Pickering
  'L1V', 'L1W', 'L1X', 'L1Y',
  // Durham Region - Ajax
  'L1S', 'L1T', 'L1Z',
  // Durham Region - Whitby
  'L1M', 'L1N', 'L1P', 'L1R',
  // Durham Region - Oshawa
  'L1G', 'L1H', 'L1J', 'L1K', 'L1L',
  // Durham Region - Clarington
  'L1B', 'L1C', 'L1E'
]);

/**
 * Checks whether a postal code string belongs to the GTA delivery area.
 * Accepts formats: "L5W1E4", "L5W 1E4", "l5w 1e4".
 * Returns object: { isGta: boolean, fsa: string, cleanCode: string }
 */
window.checkPostalCodeRegion = function(rawPostalCode) {
  if (!rawPostalCode || typeof rawPostalCode !== 'string') {
    return { isGta: false, isCanadian: false, fsa: '', cleanCode: '' };
  }
  
  const clean = rawPostalCode.trim().toUpperCase().replace(/\s+/g, '');
  if (clean.length < 3) {
    return { isGta: false, isCanadian: false, fsa: '', cleanCode: clean };
  }
  
  const fsa = clean.substring(0, 3);
  const isCanadian = /^[A-Z]\d[A-Z]\d[A-Z]\d$/.test(clean) || /^[A-Z]\d[A-Z]/.test(clean);
  const isGta = window.GTA_FSA_CODES.has(fsa);

  return { isGta, isCanadian, fsa, cleanCode: clean };
};
